import { post,get,getJ,put,deleteJ,getExcel,getTxt,uploadFile,uploadSort,upload,postOther,getPDF,deletes,importExcel } from '@/utils/axios'
import  baseURL  from '@/utils/axios/axios'
import store from '../store'

export default {
    
    // 用户信息列表
    UserInfoPager(datas){
        return get('user/selectByPage',datas)
    },
    QueryUserInfoPicByUserId(datas){
        return get('user/selectByPage/'+datas)
    },
    // 删除用户
    deleteUser(datas){
        return deleteJ('AdminStand/DeleteUser',datas)
    },
   
    // 动态列表
    DynamicPager(datas){
        return get('dynamic/selectByPage',datas)
    },
    // 动态列表
    DynamicList(datas){
        return get('dynamic/selectByPage',datas)
    },
    // 动态列表
    DynamicEdit(datas){
        return post('AdminStand/UpdateDynamic',datas)
    },
    DynamicDeleteAsync(datas){
        return post('dynamic/deleteDynamicById',datas)
    },
    PayInfoSelectByPage(datas){
        return get('payInfo/selectByPage',datas)
    },


    // 动态列表
    AdminStandCreateAsync(datas){
        return post('AdminStand/CreateAsync',datas)
    },

    // 查询用户要求
    UserGetYaoQiu(datas){
        return get('User/GetYaoQiu',datas)
    },
    // 查询用户要求
    GetAdminYaoQiu(datas){
        return get('User/GetAdminYaoQiu/'+datas)
    },

    // 主题
    UserGetZhuTi(datas){
        return get('User/GetZhuTi',datas)
    },

    // 支付
    AliPayQuery(datas){
        return get('AdminStand/AliPayQuery',datas)
    },
    WxPayQuery(datas){
        return get('AdminStand/WxPayQuery',datas)
    },

    // 举报列表
    NmJuBaoPager(datas){
        return get('nmjubao/getPage',datas)
    },
    // 举报处理
    NmJuBaoUpdate(datas){
        return post('NmJuBao/Update',datas)
    },
    // 处理解锁
    chuliJieSuo(datas){
        return post('nmjubao/chuLi',datas)
    },
    // 处理匿名举报
    NmJuBaoChulijb(datas){
        return get('nmjubao/getPage',datas)
    },
    // 处理动态
    chuliDynamic(datas){
        return post('AdminStand/ChuliDynamic',datas)
    },
    // 意见列表
    FeedbackQuery(datas){
        return get('AdminStand/FeedbackQuery',datas)
    },

    // 冻结用户
    AdminStandFrozen(datas){
        return post('user/dongJie',datas)
    },
    // 解冻用户
    AdminStandThaw(datas){
        return post('user/update',datas)
    },

    // 设置会员
    AdminStandSetVip(datas){
        return post('user/update',datas)
    },

    // 设置金币
    AdminStandSetJinbi(datas){
        return post('user/update',datas)
    },

    // 设置中介
    AdminStandSetZhongJie(datas){
        return post('AdminStand/SetZhongJie',datas)
    },

    // 绑定中介和代理团长关系
    BindZhongJie(datas){
        return post('AdminStand/BindZhongJie',datas)
    },

    // 解绑中介和代理团长关系
    UnbindZhongJie(datas){
        return post('AdminStand/UnbindZhongJie',datas)
    },
     // 中介的代理团长
     QueryAgentsByUserId(datas){
        return get('AdminStand/QueryAgentsByUserId',datas)
    },
   
    // 设置解锁动态发布次数
    setDynamicNumber(datas){
        return post('AdminStand/setDynamicNumber',datas)
    },
    // 设置解锁微信次数
    AdminStandSetUnlockNumber(datas){
        return post('AdminStand/SetUnlockNumber',datas)
    },

    // 查询解锁信息
    AdminStandQueryUserToUserChat(datas){
        return get('unlockUser/selectByPage',datas)
    },

    // 查询解锁信息
    AdminStandUpdateUserInfo(datas){
        return post('user/update',datas)
    },

    // 查询数据
    AdminStandQueryPager(datas){
        return get('AdminStand/QueryPager',datas)
    },

    // 批量插入数据
    AdminStandAddTanGuo(datas){
        return post('AdminStand/AddTanGuo',datas)
    },

    // ios
    AdminStandQueryIapInfoPager(datas){
        return get('AdminStand/QueryIapInfoPager',datas)
    },

    // 查询对话设置
    AdminMessageQueryList(datas){
        return get('AdminMessage/QueryList',datas)
    },
    AdminMessageAdd(datas){
        return post('AdminMessage/Add',datas)
    },
    AdminMessageUpdate(datas){
        return post('AdminMessage/Update',datas)
    },
    AdminMessageDelete(datas){
        return deleteJ('AdminMessage/Delete',datas)
    },
    AdminCashCashQuery(datas){
        return get('cash/getCashListPage',datas)
    },
    AdminCashUpdateCashState(datas){
        return post('cash/chuLi',datas)
    },

    AdminStandQueryShenHe(datas){
        return get('user/queryShenHe',datas)
    },
    AdminStandUpdateShenHe(datas){
        return post('user/upateReviewWeChatState',datas)
    },
    deleteUserInfoPicById(id){
        return post('User/deleteUserInfoPicById/'+id)
    },
    QueryPayInfoStati(data){
        return get('AdminDataCenter/QueryPayInfoStati',data)
    },

    QueryBlackModel(data){
        return get('blackModel/selectPage',data)
    },
    AddBlackModel(data){
        return post('blackModel/addBlackModel',data)
    },
    DeleteBlackModel(data){
        return post('blackModel/deleteBlackModel',data)
    },
    QueryUserOnline(data){
        return get('AdminDataCenter/QueryUserOnline',data)
    },
    SetWomanOnline(data){
        return get('AdminDataCenter/SetWomanOnline',data)
    },

    QueryDynamicBlack(data){
        return get('DynamicBlack/QueryDynamicBlack',data)
    },

    AddDynamicBlack(data){
        return post('DynamicBlack/AddDynamicBlack',data)
    },

    UpdateDynamicBlack(data){
        return post('DynamicBlack/UpdateDynamicBlack',data)
    },

    DeleteDynamicBlack(data){
        return post('DynamicBlack/DeleteDynamicBlack/'+data)
    },

    LaHei(data){
        return post('blackModel/addBlackModel',data)
    },

    getUserData(data,name){
        return getExcel('Export/Export',data,name)
    },
    expertFile(data,name){
        return getExcel('Export/Export',data,name)
    },
    QueryPayInfoGroupByDay(data){
        return get('AdminDataCenter/QueryPayInfoGroupByDay',data)
    },
    
    QueryTodayUserInfo(data){
        return get('AdminDataCenter/QueryTodayUserInfo',data)
    },

    QueryByMounthPayInfo(data){
        return get('AdminDataCenter/QueryByMounthPayInfo',data)
    },

    QueryMouthLiuCun(data){
        return post('AdminDataCenter/QueryMouthLiuCun',data)
    },

    QueryByDayHuoyue(data){
        return post('AdminDataCenter/QueryByDayHuoyue',data)
    },

    QueryLiuCun(data){
        return post('AdminDataCenter/QueryLiuCun',data)
    },
    QueryJinBiPriceCahs(data){
        return get('inviteReward/selectPage',data)
    },
    AdminStandUpdateUser(data){
        return post('AdminStand/UpdateUser',data)
    },
    AdminAgentQueryAgents(data){
        return get('AdminAgent/QueryAgents',data)
    },
    AdminAgentQueryZhongJies(data){
        return get('AdminAgent/QueryZhongJies',data)
    },
    AdminAgentQueryAgentByAgentZUserId(data){
        return get('AdminAgent/QueryAgentByAgentZUserId',data)
    },
    AdminAgentQueryAgentRecordByUserId(data){
        return get('AdminAgent/QueryAgentRecordByUserId',data)
    },
    AdminAgentQueryAgentByUserId(data){
        return get('AdminAgent/QueryAgentByUserId',data)
    },
    AdminAgentQueryZAgentRecordByAgentZUserId(data){
        return get('AdminAgent/QueryZAgentRecordByAgentZUserId',data)
    },
    AdminUserFileQueryUserFile(data){
        return get('userFile/selectByPage',data)
    },
    AdminUserFileUpdateUserFile(data){
        return post('userFile/updateUserFile',data)
    },
    AdminUserFileDeleteUserFile(data){
        return post('AdminUserFile/DeleteUserFile',data)
    },

    AdminUserFileQueryUserVideoFile(data){
        return get('userFile/selectByPage',data)
    },
    AdminUserFileUpdateUserVideoFile(data){
        return post('userFile/updateUserFile',data)
    },
    AdminUserFileDeleteUserVideoFile(data){
        return post('AdminUserFile/DeleteUserVideoFile',data)
    },

    ChatMsgQueryChatMsg(data){
        return get('chatMsg/selectChatSnapMsg',data)
    },

    AddChatMsg(data){
        return post('chatMsg/sendOpenImMsg',data)
    },
    QueryChatMsgConversation(data){
        return get('chatMsg/selectChatMsg',data)
    },
    Sendztmphy_tpl103099(data){
        return post('chatMsg/Sendztmphy_tpl103099',data)
    },
    
    SendZeGoMsg(data){
        return post('chatMsg/sendOpenImHuDongMsg',data)
    },
    UserInfoZhenRen(data){
        return get('user/selectByPageZhenRen',data)
    },
    UpdateYanZhiGrade(data){
        return post('user/update',data)
    },
    QueryRecommendInfo(data){
        return get('inviteReward/selectPage',data)
    },
    keyWordQuery(data){
        return get('KeyWord/keyWordQuery',data)
    },

    AgentGetListPage(data){
        return get('agent/getListPage',data)
    },
    AgentUpdateAgent(data){
        return post('agent/updateAgent',data)
    },
    AgentDeleteAgent(data){
        return post('agent/deleteAgent/'+data)
    },
    AgentCreateAgent(data){
        return post('agent/createAgent',data)
    },
    // 任务列表
    getTaskPage(data){
        return get('task/getTaskPage',data)
    },
    // 新增任务
    saveTask(data){
        return post('task/saveTask',data)
    },
    // 任务审核列表
    taskClaimService(data){
        return get('task/taskClaimService',data)
    },
    // 任务审核列表
    deleteTask(data){
        return post('task/deleteTask/'+data)
    },

    // 任务人员列表
    taskSelectUser(data){
        return get('userMarke/selectUser',data)
    },
    // 编辑代发用户信息
    taskUpdateUser(data){
        return post('userMarke/updateUser',data)
    },
    // 查询代发用户提现列表
    selectMarkeCash(data){
        return get('markeCash/selectMarkeCash',data)
    },
    // 編輯提現狀態
    updateMarkeCash(data){
        return post('markeCash/updateMarkeCash',data)
    },
    // 代发评论内容编辑
    memesReplace(data){
        return post('memes/replace',data)
    },
    // 代发评论内容
    memesList(data){
        return get('memes/list',data)
    },
    // 代发评论内容
    getShenHeTaskPage(data){
        return get('task/getShenHeTaskPage',data)
    },
    // 更新任务
    updateTask(data){
        return post('task/updateTask',data)
    },
    uploadFile(file,params){
        return uploadFile('',file,params)
    },
}